export const Countries = {
  "data": [
    {
      "code": "004",
      "iso2": "AF",
      "iso3": "AFG",
      "currency_code": "AFN",
      "name": "Afghanistan",
      "name_vi": "Afghanistan",
      "flag": "https://cdn.dutycast.com/uploads/flags/afghanistan.svg",
      "row": 0,
      "col": 1,
    },
    {
      "code": "008",
      "iso2": "AL",
      "iso3": "ALB",
      "currency_code": "ALL",
      "name": "Albania",
      "name_vi": "Albania",
      "flag": "https://cdn.dutycast.com/uploads/flags/albania.svg",
      "row": 0,
      "col": 2,
    },
    {
      "code": "012",
      "iso2": "DZ",
      "iso3": "DZA",
      "currency_code": "DZD",
      "name": "Algeria",
      "name_vi": "Algeria",
      "flag": "https://cdn.dutycast.com/uploads/flags/algeria.svg",
      "row": 0,
      "col": 3,
    },
    {
      "code": "016",
      "iso2": "AS",
      "iso3": "ASM",
      "currency_code": "USD",
      "name": "American Samoa",
      "name_vi": "American Samoa",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "020",
      "iso2": "AD",
      "iso3": "AND",
      "currency_code": "EUR",
      "name": "Andorra",
      "name_vi": "Andorra",
      "flag": "https://cdn.dutycast.com/uploads/flags/andorra.svg",
      "row": 0,
      "col": 4,
    },
    {
      "code": "024",
      "iso2": "AO",
      "iso3": "AGO",
      "currency_code": "AOA",
      "name": "Angola",
      "name_vi": "Angola",
      "flag": "https://cdn.dutycast.com/uploads/flags/angola.svg",
      "row": 0,
      "col": 5,
    },
    {
      "code": "660",
      "iso2": "AI",
      "iso3": "AIA",
      "currency_code": "XCD",
      "name": "Anguilla",
      "name_vi": "Anguilla",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "028",
      "iso2": "AG",
      "iso3": "ATG",
      "currency_code": "XCD",
      "name": "Antigua and Barbuda",
      "name_vi": "Antigua and Barbuda",
      "flag": "https://cdn.dutycast.com/uploads/flags/antigua-barbuda.svg",
      "row": 0,
      "col": 6,
    },
    {
      "code": "032",
      "iso2": "AR",
      "iso3": "ARG",
      "currency_code": "ARS",
      "name": "Argentina",
      "name_vi": "Argentina",
      "flag": "https://cdn.dutycast.com/uploads/flags/argentina.svg",
      "row": 0,
      "col": 7,
    },
    {
      "code": "051",
      "iso2": "AM",
      "iso3": "ARM",
      "currency_code": "AMD",
      "name": "Armenia",
      "name_vi": "Armenia",
      "flag": "https://cdn.dutycast.com/uploads/flags/armenia.svg",
      "row": 0,
      "col": 8,
    },
    {
      "code": "533",
      "iso2": "AB",
      "iso3": "ABW",
      "currency_code": null,
      "name": "Aruba",
      "name_vi": "Aruba",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "036",
      "iso2": "AU",
      "iso3": "AUS",
      "currency_code": "AUD",
      "name": "Australia",
      "name_vi": "Úc",
      "flag": "https://cdn.dutycast.com/uploads/flags/australia.svg",
      "row": 0,
      "col": 9,
    },
    {
      "code": "040",
      "iso2": "AT",
      "iso3": "AUT",
      "currency_code": "EUR",
      "name": "Austria",
      "name_vi": "Áo",
      "flag": "https://cdn.dutycast.com/uploads/flags/austria.svg",
      "row": 0,
      "col": 10,
    },
    {
      "code": "031",
      "iso2": "AZ",
      "iso3": "AZE",
      "currency_code": "AZN",
      "name": "Azerbaijan",
      "name_vi": "Azerbaijan",
      "flag": "https://cdn.dutycast.com/uploads/flags/azerbaijan.svg",
      "row": 0,
      "col": 11,
    },
    {
      "code": "044",
      "iso2": "BS",
      "iso3": "BHS",
      "currency_code": "BSD",
      "name": "Bahamas",
      "name_vi": "Bahamas",
      "flag": "https://cdn.dutycast.com/uploads/flags/bahamas-na.svg",
      "row": 0,
      "col": 12,
    },
    {
      "code": "048",
      "iso2": "BH",
      "iso3": "BHR",
      "currency_code": "BHD",
      "name": "Bahrain",
      "name_vi": "Ba-ranh",
      "flag": "https://cdn.dutycast.com/uploads/flags/bahrain.svg",
      "row": 0,
      "col": 13,
    },
    {
      "code": "050",
      "iso2": "BD",
      "iso3": "BGD",
      "currency_code": "BDT",
      "name": "Bangladesh",
      "name_vi": "Băng-la-đét",
      "flag": "https://cdn.dutycast.com/uploads/flags/bangladesh.svg",
      "row": 0,
      "col": 14,
    },
    {
      "code": "052",
      "iso2": "BB",
      "iso3": "BRB",
      "currency_code": "BBD",
      "name": "Barbados",
      "name_vi": "Bác-ba-đốt",
      "flag": "https://cdn.dutycast.com/uploads/flags/barbados-na.svg",
      "row": 1,
      "col": 0,
    },
    {
      "code": "112",
      "iso2": "BY",
      "iso3": "BLR",
      "currency_code": "BYN",
      "name": "Belarus",
      "name_vi": "Bê-la-rút",
      "flag": "https://cdn.dutycast.com/uploads/flags/belarus.svg",
      "row": 1,
      "col": 1,
    },
    {
      "code": "056",
      "iso2": "BE",
      "iso3": "BEL",
      "currency_code": "EUR",
      "name": "Belgium",
      "name_vi": "Bỉ",
      "flag": "https://cdn.dutycast.com/uploads/flags/belgium.svg",
      "row": 1,
      "col": 2,
    },
    {
      "code": "084",
      "iso2": "BZ",
      "iso3": "BLZ",
      "currency_code": "BZD",
      "name": "Belize",
      "name_vi": "Bê-li-xê",
      "flag": "https://cdn.dutycast.com/uploads/flags/belize-ca.svg",
      "row": 1,
      "col": 3,
    },
    {
      "code": "204",
      "iso2": "BJ",
      "iso3": "BEN",
      "currency_code": "XOF",
      "name": "Benin",
      "name_vi": "Bê-nanh",
      "flag": "https://cdn.dutycast.com/uploads/flags/benin.svg",
      "row": 1,
      "col": 4,
    },
    {
      "code": "060",
      "iso2": "BM",
      "iso3": "BMU",
      "currency_code": "BMD",
      "name": "Bermuda",
      "name_vi": "Be-mu-đa",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "064",
      "iso2": "BT",
      "iso3": "BTN",
      "currency_code": "BTN",
      "name": "Bhutan",
      "name_vi": "Bu-tan",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "068",
      "iso2": "BO",
      "iso3": "BOL",
      "currency_code": "BOB",
      "name": "Bolivia (Plurinational State of)",
      "name_vi": "Bô-li-vi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/bolivia.svg",
      "row": 1,
      "col": 5,
    },
    {
      "code": "070",
      "iso2": "BA",
      "iso3": "BIH",
      "currency_code": "BAM",
      "name": "Bosnia and Herzegovina",
      "name_vi": "Bô-xnia Héc-dê-gô-vi-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/bosnia.svg",
      "row": 1,
      "col": 6,
    },
    {
      "code": "072",
      "iso2": "BW",
      "iso3": "BWA",
      "currency_code": "BWP",
      "name": "Botswana",
      "name_vi": "Bốt-xoa-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/botswana.svg",
      "row": 1,
      "col": 7,
    },
    {
      "code": "074",
      "iso2": "BV",
      "iso3": "BVT",
      "currency_code": "NOK",
      "name": "Bouvet Island",
      "name_vi": "Quần đảo Bu-vê",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "076",
      "iso2": "BR",
      "iso3": "BRA",
      "currency_code": "BRL",
      "name": "Brazil",
      "name_vi": "Bra-xin",
      "flag": "https://cdn.dutycast.com/uploads/flags/brazil.svg",
      "row": 1,
      "col": 8,
    },
    {
      "code": "086",
      "iso2": "IO",
      "iso3": "IOT",
      "currency_code": "USD",
      "name": "British Indian Ocean Territory",
      "name_vi": "Lãnh thổ Ấn Độ Dương thuộc Anh",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "096",
      "iso2": "BN",
      "iso3": "BRN",
      "currency_code": "BND",
      "name": "Brunei Darussalam",
      "name_vi": "Bru-nây",
      "flag": "https://cdn.dutycast.com/uploads/flags/brunei.svg",
      "row": 1,
      "col": 10,
    },
    {
      "code": "100",
      "iso2": "BG",
      "iso3": "BGR",
      "currency_code": "BGN",
      "name": "Bulgaria",
      "name_vi": "Bun-ga-ri",
      "flag": "https://cdn.dutycast.com/uploads/flags/bulgaria.svg",
      "row": 1,
      "col": 11,
    },
    {
      "code": "854",
      "iso2": "BF",
      "iso3": "BFA",
      "currency_code": "XOF",
      "name": "Burkina Faso",
      "name_vi": "Buốc-ki-na Pha-xô",
      "flag": "https://cdn.dutycast.com/uploads/flags/burkina-faso.svg",
      "row": 1,
      "col": 12,
    },
    {
      "code": "108",
      "iso2": "BI",
      "iso3": "BDI",
      "currency_code": "BIF",
      "name": "Burundi",
      "name_vi": "Bu-run-đi",
      "flag": "https://cdn.dutycast.com/uploads/flags/burundi.svg",
      "row": 1,
      "col": 14,
    },
    {
      "code": "132",
      "iso2": "CV",
      "iso3": "CPV",
      "currency_code": "CVE",
      "name": "Cabo Verde",
      "name_vi": "Cáp-ve",
      "flag": "https://cdn.dutycast.com/uploads/flags/cape-verde.svg",
      "row": 2,
      "col": 3,
    },
    {
      "code": "116",
      "iso2": "KH",
      "iso3": "KHM",
      "currency_code": "KHR",
      "name": "Cambodia",
      "name_vi": "Cam-pu-chia",
      "flag": "https://cdn.dutycast.com/uploads/flags/cambodia.svg",
      "row": 2,
      "col": 0,
    },
    {
      "code": "120",
      "iso2": "CM",
      "iso3": "CMR",
      "currency_code": "XAF",
      "name": "Cameroon",
      "name_vi": "Ca-mơ-run",
      "flag": "https://cdn.dutycast.com/uploads/flags/cameroon.svg",
      "row": 2,
      "col": 1,
    },
    {
      "code": "124",
      "iso2": "CA",
      "iso3": "CAN",
      "currency_code": "CAD",
      "name": "Canada",
      "name_vi": "Ca-na-đa",
      "flag": "https://cdn.dutycast.com/uploads/flags/canada.svg",
      "row": 2,
      "col": 2,
    },
    {
      "code": "136",
      "iso2": "KY",
      "iso3": "CYM",
      "currency_code": "KYD",
      "name": "Cayman Islands",
      "name_vi": "Quần đảo Cay-man",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "140",
      "iso2": "CF",
      "iso3": "CAF",
      "currency_code": "XAF",
      "name": "Central African Republic",
      "name_vi": "Cộng Hoà Trung Phi",
      "flag": "https://cdn.dutycast.com/uploads/flags/central-african-republic.svg",
      "row": 2,
      "col": 4,
    },
    {
      "code": "148",
      "iso2": "TD",
      "iso3": "TCD",
      "currency_code": "XAF",
      "name": "Chad",
      "name_vi": "Sát",
      "flag": "https://cdn.dutycast.com/uploads/flags/chad.svg",
      "row": 2,
      "col": 5,
    },
    {
      "code": "152",
      "iso2": "CL",
      "iso3": "CHL",
      "currency_code": "CLP",
      "name": "Chile",
      "name_vi": "Chi-lê",
      "flag": "https://cdn.dutycast.com/uploads/flags/chile.svg",
      "row": 2,
      "col": 6,
    },
    {
      "code": "156",
      "iso2": "CN",
      "iso3": "CHN",
      "currency_code": "CNY",
      "name": "China",
      "name_vi": "Trung Quốc",
      "flag": "https://cdn.dutycast.com/uploads/flags/china-2.svg",
      "row": 2,
      "col": 7,
    },
    {
      "code": "162",
      "iso2": "CX",
      "iso3": "CXR",
      "currency_code": "AUD",
      "name": "Christmas Island",
      "name_vi": "Đảo Giáng Sinh",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "166",
      "iso2": "CC",
      "iso3": "CCK",
      "currency_code": "AUD",
      "name": "Cocos (Keeling) Islands",
      "name_vi": "Quần đảo Co-co-xợ (Khi-lịng)",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "170",
      "iso2": "CO",
      "iso3": "COL",
      "currency_code": "COP",
      "name": "Colombia",
      "name_vi": "Cô-lôm-bi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/colombia.svg",
      "row": 2,
      "col": 8,
    },
    {
      "code": "174",
      "iso2": "KM",
      "iso3": "COM",
      "currency_code": "KMF",
      "name": "Comoros",
      "name_vi": "Cô-mo",
      "flag": "https://cdn.dutycast.com/uploads/flags/comoros.svg",
      "row": 2,
      "col": 9,
    },
    {
      "code": "178",
      "iso2": "CG",
      "iso3": "COG",
      "currency_code": "XAF",
      "name": "Congo",
      "name_vi": "Công-gô",
      "flag": "https://cdn.dutycast.com/uploads/flags/republic-of-the-congo.svg",
      "row": 10,
      "col": 2,
    },
    {
      "code": "180",
      "iso2": "CD",
      "iso3": "COD",
      "currency_code": "CDF",
      "name": "Congo, Democratic Republic of",
      "name_vi": "Cộng hoà Dân chủ Công-gô",
      "flag": "https://cdn.dutycast.com/uploads/flags/democratic-republic-of-congo.svg",
      "row": 3,
      "col": 0,
    },
    {
      "code": "184",
      "iso2": "CK",
      "iso3": "COK",
      "currency_code": "NZD",
      "name": "Cook Islands",
      "name_vi": "Quần đảo Khu-khợ",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "188",
      "iso2": "CR",
      "iso3": "CRI",
      "currency_code": "CRC",
      "name": "Costa Rica",
      "name_vi": "Costa Rica",
      "flag": "https://cdn.dutycast.com/uploads/flags/costarica.svg",
      "row": 2,
      "col": 10,
    },
    {
      "code": "191",
      "iso2": "HR",
      "iso3": "HRV",
      "currency_code": "EUR",
      "name": "Croatia",
      "name_vi": "Croatia",
      "flag": "https://cdn.dutycast.com/uploads/flags/croatia.svg",
      "row": 2,
      "col": 11,
    },
    {
      "code": "192",
      "iso2": "CU",
      "iso3": "CUB",
      "currency_code": "CUP",
      "name": "Cuba",
      "name_vi": "Cu-ba",
      "flag": "https://cdn.dutycast.com/uploads/flags/cuba.svg",
      "row": 2,
      "col": 12,
    },
    {
      "code": "196",
      "iso2": "CY",
      "iso3": "CYP",
      "currency_code": "EUR",
      "name": "Cyprus",
      "name_vi": "Síp",
      "flag": "https://cdn.dutycast.com/uploads/flags/cyprus.svg",
      "row": 2,
      "col": 13,
    },
    {
      "code": "203",
      "iso2": "CZ",
      "iso3": "CZE",
      "currency_code": "CZK",
      "name": "Czech Republic",
      "name_vi": "Séc",
      "flag": "https://cdn.dutycast.com/uploads/flags/czech.svg",
      "row": 2,
      "col": 14,
    },
    {
      "code": "384",
      "iso2": "CI",
      "iso3": "CIV",
      "currency_code": "XOF",
      "name": "Côte d'Ivoire",
      "name_vi": "Bờ Biển Ngà",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "208",
      "iso2": "DK",
      "iso3": "DNK",
      "currency_code": "DKK",
      "name": "Denmark",
      "name_vi": "Đan Mạch",
      "flag": "https://cdn.dutycast.com/uploads/flags/denmark.svg",
      "row": 3,
      "col": 1,
    },
    {
      "code": "262",
      "iso2": "DJ",
      "iso3": "DJI",
      "currency_code": "DJF",
      "name": "Djibouti",
      "name_vi": "Gi-bu-ti",
      "flag": "https://cdn.dutycast.com/uploads/flags/djibouti.svg",
      "row": 3,
      "col": 2,
    },
    {
      "code": "212",
      "iso2": "DM",
      "iso3": "DMA",
      "currency_code": "XCD",
      "name": "Dominica",
      "name_vi": "Đô-mi-ni-ca-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/dominica.svg",
      "row": 3,
      "col": 3,
    },
    {
      "code": "214",
      "iso2": "DO",
      "iso3": "DOM",
      "currency_code": "DOP",
      "name": "Dominican Republic",
      "name_vi": "Cộng hoà Đô-mi-ni-ca-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/dominican-republic-na.svg",
      "row": 3,
      "col": 4,
    },
    {
      "code": "218",
      "iso2": "EC",
      "iso3": "ECU",
      "currency_code": "USD",
      "name": "Ecuador",
      "name_vi": "Ê-cu-a-đo",
      "flag": "https://cdn.dutycast.com/uploads/flags/ecuador.svg",
      "row": 3,
      "col": 6,
    },
    {
      "code": "818",
      "iso2": "EG",
      "iso3": "EGY",
      "currency_code": "EGP",
      "name": "Egypt",
      "name_vi": "Ai Cập",
      "flag": "https://cdn.dutycast.com/uploads/flags/egypt.svg",
      "row": 3,
      "col": 7,
    },
    {
      "code": "222",
      "iso2": "SV",
      "iso3": "SLV",
      "currency_code": "USD",
      "name": "El Salvador",
      "name_vi": "En Xan-va-đo",
      "flag": "https://cdn.dutycast.com/uploads/flags/el-salvador-ca.svg",
      "row": 3,
      "col": 8,
    },
    {
      "code": "226",
      "iso2": "GQ",
      "iso3": "GNQ",
      "currency_code": "XAF",
      "name": "Equatorial Guinea",
      "name_vi": "Ghi-xê Xích Đạo",
      "flag": "https://cdn.dutycast.com/uploads/flags/equatorial-guinea.svg",
      "row": 3,
      "col": 10,
    },
    {
      "code": "232",
      "iso2": "ER",
      "iso3": "ERI",
      "currency_code": "ETB",
      "name": "Eritrea",
      "name_vi": "Ê-ri-tơ-rê-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/eritrea.svg",
      "row": 3,
      "col": 11,
    },
    {
      "code": "233",
      "iso2": "EE",
      "iso3": "EST",
      "currency_code": "EUR",
      "name": "Estonia",
      "name_vi": "E-xtô-ni-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/estonia.svg",
      "row": 3,
      "col": 12,
    },
    {
      "code": "748",
      "iso2": "SZ",
      "iso3": "SWZ",
      "currency_code": "SZL",
      "name": "Eswatini",
      "name_vi": "Eswatini",
      "flag": "https://cdn.dutycast.com/uploads/flags/swaziland.svg",
      "row": 11,
      "col": 12,
    },
    {
      "code": "231",
      "iso2": "ET",
      "iso3": "ETH",
      "currency_code": "ETB",
      "name": "Ethiopia",
      "name_vi": "Ê-ti-ô-pi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/ethiopia.svg",
      "row": 3,
      "col": 13,
    },
    {
      "code": "238",
      "iso2": "FK",
      "iso3": "FLK",
      "currency_code": "FKP",
      "name": "Falkland Islands (Malvinas)",
      "name_vi": "Quần Đảo Phoa-kh-lận-đợ (Man-vi-na)",
      "flag": "https://cdn.dutycast.com/uploads/flags/falkland-islands.svg",
      "row": 4,
      "col": 0,
    },
    {
      "code": "234",
      "iso2": "FO",
      "iso3": "FRO",
      "currency_code": "DKK",
      "name": "Faroe Islands",
      "name_vi": "Quần đảo Pha-rô",
      "flag": "https://cdn.dutycast.com/uploads/flags/faroe-islands.svg",
      "row": 4,
      "col": 1,
    },
    {
      "code": "242",
      "iso2": "FJ",
      "iso3": "FJI",
      "currency_code": "FJD",
      "name": "Fiji",
      "name_vi": "Phi-gi",
      "flag": "https://cdn.dutycast.com/uploads/flags/fiji.svg",
      "row": 4,
      "col": 2,
    },
    {
      "code": "246",
      "iso2": "FI",
      "iso3": "FIN",
      "currency_code": "EUR",
      "name": "Finland",
      "name_vi": "Phần Lan",
      "flag": "https://cdn.dutycast.com/uploads/flags/finland.svg",
      "row": 4,
      "col": 3,
    },
    {
      "code": "251",
      "iso2": "FR",
      "iso3": "FRA",
      "currency_code": "EUR",
      "name": "France",
      "name_vi": "Pháp",
      "flag": "https://cdn.dutycast.com/uploads/flags/france.svg",
      "row": 4,
      "col": 4,
    },
    {
      "code": "254",
      "iso2": "GF",
      "iso3": "GUF",
      "currency_code": "EUR",
      "name": "French Guiana",
      "name_vi": "Ghi-a-na Pháp",
      "flag": "https://cdn.dutycast.com/uploads/flags/french-guiana.svg",
      "row": 4,
      "col": 5,
    },
    {
      "code": "258",
      "iso2": "PF",
      "iso3": "PYF",
      "currency_code": "XPF",
      "name": "French Polynesia",
      "name_vi": "Pô-li-nê-xi Pháp",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "260",
      "iso2": "FQ",
      "iso3": "ATF",
      "currency_code": null,
      "name": "French Southern territories",
      "name_vi": "Vùng lãnh thổ phía Nam thuộc Pháp",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "266",
      "iso2": "GA",
      "iso3": "GAB",
      "currency_code": "XAF",
      "name": "Gabon",
      "name_vi": "Ga-bông",
      "flag": "https://cdn.dutycast.com/uploads/flags/gabon.svg",
      "row": 4,
      "col": 6,
    },
    {
      "code": "270",
      "iso2": "GM",
      "iso3": "GMB",
      "currency_code": "GMD",
      "name": "Gambia",
      "name_vi": "Găm-bi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/gambia.svg",
      "row": 4,
      "col": 7,
    },
    {
      "code": "268",
      "iso2": "GE",
      "iso3": "GEO",
      "currency_code": "GEL",
      "name": "Georgia",
      "name_vi": "Giê-oóc-gi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/georgia.svg",
      "row": 4,
      "col": 8,
    },
    {
      "code": "276",
      "iso2": "DE",
      "iso3": "DEU",
      "currency_code": "EUR",
      "name": "Germany",
      "name_vi": "Đức",
      "flag": "https://cdn.dutycast.com/uploads/flags/germany.svg",
      "row": 4,
      "col": 9,
    },
    {
      "code": "288",
      "iso2": "GH",
      "iso3": "GHA",
      "currency_code": "GHS",
      "name": "Ghana",
      "name_vi": "Gha-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/ghana.svg",
      "row": 4,
      "col": 10,
    },
    {
      "code": "292",
      "iso2": "GI",
      "iso3": "GIB",
      "currency_code": "GIP",
      "name": "Gibraltar",
      "name_vi": "Gi-boa-tha",
      "flag": "https://cdn.dutycast.com/uploads/flags/gibraltar.svg",
      "row": 4,
      "col": 11,
    },
    {
      "code": "300",
      "iso2": "GR",
      "iso3": "GRC",
      "currency_code": "EUR",
      "name": "Greece",
      "name_vi": "Hy Lạp",
      "flag": "https://cdn.dutycast.com/uploads/flags/greece.svg",
      "row": 4,
      "col": 12,
    },
    {
      "code": "304",
      "iso2": "GL",
      "iso3": "GRL",
      "currency_code": "DKK",
      "name": "Greenland",
      "name_vi": "Đảo Băng",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "308",
      "iso2": "GD",
      "iso3": "GRD",
      "currency_code": "XCD",
      "name": "Grenada",
      "name_vi": "Grê-na-đa",
      "flag": "https://cdn.dutycast.com/uploads/flags/grenada-na.svg",
      "row": 4,
      "col": 13,
    },
    {
      "code": "316",
      "iso2": "GU",
      "iso3": "GUM",
      "currency_code": "USD",
      "name": "Guam",
      "name_vi": "Gu-ăm",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "320",
      "iso2": "GT",
      "iso3": "GTM",
      "currency_code": "GTQ",
      "name": "Guatemala",
      "name_vi": "Gua-tê-ma-la",
      "flag": "https://cdn.dutycast.com/uploads/flags/guatemala.svg",
      "row": 4,
      "col": 14,
    },
    {
      "code": "324",
      "iso2": "GN",
      "iso3": "GIN",
      "currency_code": "GNF",
      "name": "Guinea",
      "name_vi": "Ghi-nê",
      "flag": "https://cdn.dutycast.com/uploads/flags/guinea.svg",
      "row": 5,
      "col": 1,
    },
    {
      "code": "624",
      "iso2": "GW",
      "iso3": "GNB",
      "currency_code": "XOF",
      "name": "Guinea-Bissau",
      "name_vi": "Ghi-nê Bít-xao",
      "flag": "https://cdn.dutycast.com/uploads/flags/guinea-bissau.svg",
      "row": 5,
      "col": 2,
    },
    {
      "code": "328",
      "iso2": "GY",
      "iso3": "GUY",
      "currency_code": "GYD",
      "name": "Guyana",
      "name_vi": "Guy-a-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/guyana.svg",
      "row": 5,
      "col": 3,
    },
    {
      "code": "332",
      "iso2": "HT",
      "iso3": "HTI",
      "currency_code": "HTG",
      "name": "Haiti",
      "name_vi": "Ha-i-ti",
      "flag": "https://cdn.dutycast.com/uploads/flags/haiti-na.svg",
      "row": 5,
      "col": 4,
    },
    {
      "code": "334",
      "iso2": "HM",
      "iso3": "HMD",
      "currency_code": "AUD",
      "name": "Heard and McDonald Islands",
      "name_vi": "Đảo He-ợ-đợ và Quần Đảo Mợc-đo-nậ-đợ",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "340",
      "iso2": "HN",
      "iso3": "HND",
      "currency_code": "HNL",
      "name": "Honduras",
      "name_vi": "Hôn-đu-rát",
      "flag": "https://cdn.dutycast.com/uploads/flags/honduras-ca.svg",
      "row": 5,
      "col": 5,
    },
    {
      "code": "344",
      "iso2": "HK",
      "iso3": "HKG",
      "currency_code": "HKD",
      "name": "Hong Kong",
      "name_vi": "Hồng Kông",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "348",
      "iso2": "HU",
      "iso3": "HUN",
      "currency_code": "HUF",
      "name": "Hungary",
      "name_vi": "Hun-ga-ri",
      "flag": "https://cdn.dutycast.com/uploads/flags/hungary.svg",
      "row": 5,
      "col": 6,
    },
    {
      "code": "352",
      "iso2": "IS",
      "iso3": "ISL",
      "currency_code": "ISK",
      "name": "Iceland",
      "name_vi": "Băng Đảo",
      "flag": "https://cdn.dutycast.com/uploads/flags/iceland.svg",
      "row": 5,
      "col": 7,
    },
    {
      "code": "699",
      "iso2": "IN",
      "iso3": "IND",
      "currency_code": "INR",
      "name": "India",
      "name_vi": "Ấn Độ",
      "flag": "https://cdn.dutycast.com/uploads/flags/india.svg",
      "row": 5,
      "col": 8,
    },
    {
      "code": "360",
      "iso2": "ID",
      "iso3": "IDN",
      "currency_code": "IDR",
      "name": "Indonesia",
      "name_vi": "In-đô-nê-si-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/indonesia.svg",
      "row": 5,
      "col": 9,
    },
    {
      "code": "364",
      "iso2": "IR",
      "iso3": "IRN",
      "currency_code": "IRR",
      "name": "Iran (Islamic Republic of)",
      "name_vi": "I-ran",
      "flag": "https://cdn.dutycast.com/uploads/flags/iran.svg",
      "row": 5,
      "col": 10,
    },
    {
      "code": "368",
      "iso2": "IQ",
      "iso3": "IRQ",
      "currency_code": "IQD",
      "name": "Iraq",
      "name_vi": "I-rắc",
      "flag": "https://cdn.dutycast.com/uploads/flags/iraq.svg",
      "row": 5,
      "col": 11,
    },
    {
      "code": "372",
      "iso2": "IE",
      "iso3": "IRL",
      "currency_code": "EUR",
      "name": "Ireland",
      "name_vi": "Ai-len",
      "flag": "https://cdn.dutycast.com/uploads/flags/ireland.svg",
      "row": 5,
      "col": 12,
    },
    {
      "code": "376",
      "iso2": "IL",
      "iso3": "ISR",
      "currency_code": "ILS",
      "name": "Israel",
      "name_vi": "I-xra-en",
      "flag": "https://cdn.dutycast.com/uploads/flags/israel.svg",
      "row": 5,
      "col": 14,
    },
    {
      "code": "381",
      "iso2": "IT",
      "iso3": "ITA",
      "currency_code": "EUR",
      "name": "Italy",
      "name_vi": "Ý",
      "flag": "https://cdn.dutycast.com/uploads/flags/italy.svg",
      "row": 6,
      "col": 0,
    },
    {
      "code": "388",
      "iso2": "JM",
      "iso3": "JAM",
      "currency_code": "JMD",
      "name": "Jamaica",
      "name_vi": "Gia-mai-ca",
      "flag": "https://cdn.dutycast.com/uploads/flags/jamaica.svg",
      "row": 6,
      "col": 1,
    },
    {
      "code": "392",
      "iso2": "JP",
      "iso3": "JPN",
      "currency_code": "JPY",
      "name": "Japan",
      "name_vi": "Nhật",
      "flag": "https://cdn.dutycast.com/uploads/flags/japan.svg",
      "row": 6,
      "col": 2,
    },
    {
      "code": "400",
      "iso2": "JO",
      "iso3": "JOR",
      "currency_code": "JOD",
      "name": "Jordan",
      "name_vi": "Gioóc-đa-ni",
      "flag": "https://cdn.dutycast.com/uploads/flags/jordan.svg",
      "row": 6,
      "col": 4,
    },
    {
      "code": "398",
      "iso2": "KZ",
      "iso3": "KAZ",
      "currency_code": "KZT",
      "name": "Kazakhstan",
      "name_vi": "Ca-dắc-xtan",
      "flag": "https://cdn.dutycast.com/uploads/flags/kazakhstan.svg",
      "row": 6,
      "col": 5,
    },
    {
      "code": "404",
      "iso2": "KE",
      "iso3": "KEN",
      "currency_code": "KES",
      "name": "Kenya",
      "name_vi": "Kê-ni-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/kenya.svg",
      "row": 6,
      "col": 6,
    },
    {
      "code": "296",
      "iso2": "KI",
      "iso3": "KIR",
      "currency_code": "AUD",
      "name": "Kiribati",
      "name_vi": "Ki-ri-ba-ti",
      "flag": "https://cdn.dutycast.com/uploads/flags/kiribati.svg",
      "row": 6,
      "col": 7,
    },
    {
      "code": "408",
      "iso2": "KP",
      "iso3": "PRK",
      "currency_code": "KPW",
      "name": "Korea, Democratic People's Republic of",
      "name_vi": "Triều Tiên",
      "flag": "https://cdn.dutycast.com/uploads/flags/north-korea.svg",
      "row": 9,
      "col": 2,
    },
    {
      "code": "410",
      "iso2": "KR",
      "iso3": "KOR",
      "currency_code": "KRW",
      "name": "Korea, Republic of",
      "name_vi": "Hàn Quốc",
      "flag": "https://cdn.dutycast.com/uploads/flags/korea.svg",
      "row": 6,
      "col": 8,
    },
    {
      "code": "895",
      "iso2": "KO",
      "iso3": "KSV",
      "currency_code": null,
      "name": "Kosovo",
      "name_vi": "",
      "flag": "https://cdn.dutycast.com/uploads/flags/kosovo.svg",
      "row": 6,
      "col": 9,
    },
    {
      "code": "414",
      "iso2": "KW",
      "iso3": "KWT",
      "currency_code": "KWD",
      "name": "Kuwait",
      "name_vi": "Cô-oét",
      "flag": "https://cdn.dutycast.com/uploads/flags/kuwait.svg",
      "row": 6,
      "col": 10,
    },
    {
      "code": "417",
      "iso2": "KG",
      "iso3": "KGZ",
      "currency_code": "KGS",
      "name": "Kyrgyzstan",
      "name_vi": "Cư-rơ-gư-dơ-xtan",
      "flag": "https://cdn.dutycast.com/uploads/flags/kyrgyzstan.svg",
      "row": 6,
      "col": 11,
    },
    {
      "code": "418",
      "iso2": "LA",
      "iso3": "LAO",
      "currency_code": "LAK",
      "name": "Lao, People's Democratic Republic",
      "name_vi": "Lào",
      "flag": "https://cdn.dutycast.com/uploads/flags/laos.svg",
      "row": 6,
      "col": 12,
    },
    {
      "code": "428",
      "iso2": "LV",
      "iso3": "LVA",
      "currency_code": "EUR",
      "name": "Latvia",
      "name_vi": "Lát-vi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/latvia.svg",
      "row": 6,
      "col": 13,
    },
    {
      "code": "422",
      "iso2": "LB",
      "iso3": "LBN",
      "currency_code": "LBP",
      "name": "Lebanon",
      "name_vi": "Li Băng",
      "flag": "https://cdn.dutycast.com/uploads/flags/lebanon.svg",
      "row": 6,
      "col": 14,
    },
    {
      "code": "426",
      "iso2": "LS",
      "iso3": "LSO",
      "currency_code": "LSL",
      "name": "Lesotho",
      "name_vi": "Lê-xô-thô",
      "flag": "https://cdn.dutycast.com/uploads/flags/lesotho.svg",
      "row": 7,
      "col": 0,
    },
    {
      "code": "430",
      "iso2": "LR",
      "iso3": "LBR",
      "currency_code": "LRD",
      "name": "Liberia",
      "name_vi": "Li-bê-ri-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/liberia.svg",
      "row": 7,
      "col": 1,
    },
    {
      "code": "434",
      "iso2": "LY",
      "iso3": "LBY",
      "currency_code": "LYD",
      "name": "Libya",
      "name_vi": "Libi",
      "flag": "https://cdn.dutycast.com/uploads/flags/libya.svg",
      "row": 7,
      "col": 2,
    },
    {
      "code": "438",
      "iso2": "LI",
      "iso3": "LIE",
      "currency_code": "CHF",
      "name": "Liechtenstein",
      "name_vi": "Lích-tên- xtanh",
      "flag": "https://cdn.dutycast.com/uploads/flags/liechtenstein.svg",
      "row": 7,
      "col": 3,
    },
    {
      "code": "440",
      "iso2": "LT",
      "iso3": "LTU",
      "currency_code": "EUR",
      "name": "Lithuania",
      "name_vi": "Litva",
      "flag": "https://cdn.dutycast.com/uploads/flags/lithuania.svg",
      "row": 7,
      "col": 4,
    },
    {
      "code": "442",
      "iso2": "LU",
      "iso3": "LUX",
      "currency_code": "EUR",
      "name": "Luxembourg",
      "name_vi": "Lúc-xăm-bua",
      "flag": "https://cdn.dutycast.com/uploads/flags/luxembourg.svg",
      "row": 7,
      "col": 5,
    },
    {
      "code": "446",
      "iso2": "MO",
      "iso3": "MAC",
      "currency_code": "MOP",
      "name": "Macao, China Special Administrative Region",
      "name_vi": "Ma-cao",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "450",
      "iso2": "MG",
      "iso3": "MDG",
      "currency_code": "MGA",
      "name": "Madagascar",
      "name_vi": "Ma-đa-gát-xca",
      "flag": "https://cdn.dutycast.com/uploads/flags/madagascar.svg",
      "row": 7,
      "col": 7,
    },
    {
      "code": "454",
      "iso2": "MW",
      "iso3": "MWI",
      "currency_code": "MWK",
      "name": "Malawi",
      "name_vi": "Ma-la-uy",
      "flag": "https://cdn.dutycast.com/uploads/flags/malawi.svg",
      "row": 7,
      "col": 8,
    },
    {
      "code": "458",
      "iso2": "MY",
      "iso3": "MYS",
      "currency_code": "MYR",
      "name": "Malaysia",
      "name_vi": "Ma-lai-xi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/malaysia.svg",
      "row": 7,
      "col": 9,
    },
    {
      "code": "462",
      "iso2": "MV",
      "iso3": "MDV",
      "currency_code": "MVR",
      "name": "Maldives",
      "name_vi": "Man-đi-vơ",
      "flag": "https://cdn.dutycast.com/uploads/flags/maldives.svg",
      "row": 7,
      "col": 10,
    },
    {
      "code": "466",
      "iso2": "ML",
      "iso3": "MLI",
      "currency_code": "XOF",
      "name": "Mali",
      "name_vi": "Ma-li",
      "flag": "https://cdn.dutycast.com/uploads/flags/mali.svg",
      "row": 7,
      "col": 11,
    },
    {
      "code": "470",
      "iso2": "MT",
      "iso3": "MLT",
      "currency_code": "EUR",
      "name": "Malta",
      "name_vi": "Man-ta",
      "flag": "https://cdn.dutycast.com/uploads/flags/malta.svg",
      "row": 7,
      "col": 12,
    },
    {
      "code": "584",
      "iso2": "MH",
      "iso3": "MHL",
      "currency_code": "USD",
      "name": "Marshall Islands",
      "name_vi": "Quần Đảo Mác-san",
      "flag": "https://cdn.dutycast.com/uploads/flags/marshall-islands.svg",
      "row": 7,
      "col": 14,
    },
    {
      "code": "478",
      "iso2": "MR",
      "iso3": "MRT",
      "currency_code": "MRU",
      "name": "Mauritania",
      "name_vi": "Mô-ri-ta-ni-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/mauritania.svg",
      "row": 8,
      "col": 0,
    },
    {
      "code": "480",
      "iso2": "MU",
      "iso3": "MUS",
      "currency_code": "MUR",
      "name": "Mauritius",
      "name_vi": "Mô-ri-xơ",
      "flag": "https://cdn.dutycast.com/uploads/flags/mauritius.svg",
      "row": 8,
      "col": 1,
    },
    {
      "code": "175",
      "iso2": "YT",
      "iso3": "MYT",
      "currency_code": "EUR",
      "name": "Mayotte",
      "name_vi": "May-o-thợ",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "484",
      "iso2": "MX",
      "iso3": "MEX",
      "currency_code": "MXN",
      "name": "Mexico",
      "name_vi": "Mê-hi-cô",
      "flag": "https://cdn.dutycast.com/uploads/flags/mexico.svg",
      "row": 8,
      "col": 2,
    },
    {
      "code": "583",
      "iso2": "FM",
      "iso3": "FSM",
      "currency_code": "USD",
      "name": "Micronesia (Federated States of)",
      "name_vi": "Liên bang Mi-crô-nê-di-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/micronesia.svg",
      "row": 8,
      "col": 3,
    },
    {
      "code": "488",
      "iso2": "MI",
      "iso3": "MID",
      "currency_code": null,
      "name": "Midway Islands",
      "name_vi": "Rạn san hô vòng Midway",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "498",
      "iso2": "MD",
      "iso3": "MDA",
      "currency_code": "MDL",
      "name": "Moldova, Republic of",
      "name_vi": "Mon-đô-va",
      "flag": "https://cdn.dutycast.com/uploads/flags/moldova.svg",
      "row": 8,
      "col": 4,
    },
    {
      "code": "496",
      "iso2": "MN",
      "iso3": "MNG",
      "currency_code": "MNT",
      "name": "Mongolia",
      "name_vi": "Mông Cổ",
      "flag": "https://cdn.dutycast.com/uploads/flags/mongolia.svg",
      "row": 8,
      "col": 6,
    },
    {
      "code": "499",
      "iso2": "ME",
      "iso3": "MNE",
      "currency_code": "EUR",
      "name": "Montenegro",
      "name_vi": "Môn-tê-nê-grô",
      "flag": "https://cdn.dutycast.com/uploads/flags/montenegro.svg",
      "row": 8,
      "col": 7,
    },
    {
      "code": "500",
      "iso2": "MS",
      "iso3": "MSR",
      "currency_code": "XCD",
      "name": "Montserrat",
      "name_vi": "Mon-xe-rạc",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "504",
      "iso2": "MA",
      "iso3": "MAR",
      "currency_code": "MAD",
      "name": "Morocco",
      "name_vi": "Ma-rốc",
      "flag": "https://cdn.dutycast.com/uploads/flags/marocco.svg",
      "row": 7,
      "col": 13,
    },
    {
      "code": "508",
      "iso2": "MZ",
      "iso3": "MOZ",
      "currency_code": "MZN",
      "name": "Mozambique",
      "name_vi": "Mô-dăm-bích",
      "flag": "https://cdn.dutycast.com/uploads/flags/mozanbique.svg",
      "row": 8,
      "col": 8,
    },
    {
      "code": "104",
      "iso2": "MM",
      "iso3": "MMR",
      "currency_code": "MMK",
      "name": "Myanmar",
      "name_vi": "Mi-an-ma",
      "flag": "https://cdn.dutycast.com/uploads/flags/burma.svg",
      "row": 1,
      "col": 13,
    },
    {
      "code": "516",
      "iso2": "NA",
      "iso3": "NAM",
      "currency_code": "NAD",
      "name": "Namibia",
      "name_vi": "Nam-mi-bi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/namibia.svg",
      "row": 8,
      "col": 9,
    },
    {
      "code": "520",
      "iso2": "NR",
      "iso3": "NRU",
      "currency_code": "AUD",
      "name": "Nauru",
      "name_vi": "Nau-ru",
      "flag": "https://cdn.dutycast.com/uploads/flags/nauru.svg",
      "row": 8,
      "col": 10,
    },
    {
      "code": "524",
      "iso2": "NP",
      "iso3": "NPL",
      "currency_code": "NPR",
      "name": "Nepal",
      "name_vi": "Nê-pan",
      "flag": "https://cdn.dutycast.com/uploads/flags/nepal.svg",
      "row": 8,
      "col": 11,
    },
    {
      "code": "528",
      "iso2": "NL",
      "iso3": "NLD",
      "currency_code": "EUR",
      "name": "Netherlands",
      "name_vi": "Hà Lan",
      "flag": "https://cdn.dutycast.com/uploads/flags/netherlands.svg",
      "row": 8,
      "col": 12,
    },
    {
      "code": "530",
      "iso2": "AN",
      "iso3": "ANT",
      "currency_code": null,
      "name": "Netherlands Antilles",
      "name_vi": "Tây Ấn Hà Lan",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "540",
      "iso2": "NC",
      "iso3": "NCL",
      "currency_code": "XPF",
      "name": "New Caledonia",
      "name_vi": "Niu Ca-lê-đô-ni-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "554",
      "iso2": "NZ",
      "iso3": "NZL",
      "currency_code": "NZD",
      "name": "New Zealand",
      "name_vi": "Niu Di-lân",
      "flag": "https://cdn.dutycast.com/uploads/flags/new-zealand.svg",
      "row": 8,
      "col": 13,
    },
    {
      "code": "558",
      "iso2": "NI",
      "iso3": "NIC",
      "currency_code": "NIO",
      "name": "Nicaragua",
      "name_vi": "Ni-ca-ra-goa",
      "flag": "https://cdn.dutycast.com/uploads/flags/nicaragua-ca.svg",
      "row": 8,
      "col": 14,
    },
    {
      "code": "562",
      "iso2": "NE",
      "iso3": "NER",
      "currency_code": "XOF",
      "name": "Niger",
      "name_vi": "Ni-giê",
      "flag": "https://cdn.dutycast.com/uploads/flags/niger.svg",
      "row": 9,
      "col": 0,
    },
    {
      "code": "566",
      "iso2": "NG",
      "iso3": "NGA",
      "currency_code": "NGN",
      "name": "Nigeria",
      "name_vi": "Ni-giê-ri-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/nigeria.svg",
      "row": 9,
      "col": 1,
    },
    {
      "code": "570",
      "iso2": "NU",
      "iso3": "NIU",
      "currency_code": "NZD",
      "name": "Niue",
      "name_vi": "Ni-u-e",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "574",
      "iso2": "NF",
      "iso3": "NFK",
      "currency_code": "AUD",
      "name": "Norfolk Island",
      "name_vi": "Đảo Noócphôn",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "807",
      "iso2": "MK",
      "iso3": "MKD",
      "currency_code": "MKD",
      "name": "North Macedonia, Republic of",
      "name_vi": "Bắc Ma-xê-đô-ni-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/macedonia.svg",
      "row": 7,
      "col": 6,
    },
    {
      "code": "580",
      "iso2": "MP",
      "iso3": "MNP",
      "currency_code": "USD",
      "name": "Northern Mariana Islands",
      "name_vi": "Bắc Quần Đảo Ma-ri-a-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "579",
      "iso2": "NO",
      "iso3": "NOR",
      "currency_code": "NOK",
      "name": "Norway",
      "name_vi": "Na Uy",
      "flag": "https://cdn.dutycast.com/uploads/flags/norway.svg",
      "lang": "nb",
      "row": 9,
      "col": 3,
    },
    {
      "code": "512",
      "iso2": "OM",
      "iso3": "OMN",
      "currency_code": "OMR",
      "name": "Oman",
      "name_vi": "Ô-man",
      "flag": "https://cdn.dutycast.com/uploads/flags/oman.svg",
      "row": 9,
      "col": 4,
    },
    {
      "code": "582",
      "iso2": "PC",
      "iso3": "PCE",
      "currency_code": null,
      "name": "Pacific Islands",
      "name_vi": "Quần đảo Thái Bình Dương",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "586",
      "iso2": "PK",
      "iso3": "PAK",
      "currency_code": "PKR",
      "name": "Pakistan",
      "name_vi": "Pa-ki-xtan",
      "flag": "https://cdn.dutycast.com/uploads/flags/pakistan.svg",
      "row": 9,
      "col": 5,
    },
    {
      "code": "585",
      "iso2": "PW",
      "iso3": "PLW",
      "currency_code": "USD",
      "name": "Palau",
      "name_vi": "Pa-lau",
      "flag": "https://cdn.dutycast.com/uploads/flags/palau.svg",
      "row": 9,
      "col": 6,
    },
    {
      "code": "275",
      "iso2": "GZ",
      "iso3": "GZS",
      "currency_code": null,
      "name": "Palestine, State of",
      "name_vi": "Pa-lét-xtin",
      "flag": "https://cdn.dutycast.com/uploads/flags/palestine.svg",
      "row": 9,
      "col": 7,
    },
    {
      "code": "591",
      "iso2": "PA",
      "iso3": "PAN",
      "currency_code": "PAB",
      "name": "Panama",
      "name_vi": "Pa-na-ma",
      "flag": "https://cdn.dutycast.com/uploads/flags/panama-ca.svg",
      "row": 9,
      "col": 8,
    },
    {
      "code": "598",
      "iso2": "PG",
      "iso3": "PNG",
      "currency_code": "PGK",
      "name": "Papua New Guinea",
      "name_vi": "Pa-pua Niu Ghi-nê",
      "flag": "https://cdn.dutycast.com/uploads/flags/papua-new-guinea.svg",
      "row": 9,
      "col": 9,
    },
    {
      "code": "600",
      "iso2": "PY",
      "iso3": "PRY",
      "currency_code": "PYG",
      "name": "Paraguay",
      "name_vi": "Pa-ra-goay",
      "flag": "https://cdn.dutycast.com/uploads/flags/paraguay.svg",
      "row": 9,
      "col": 10,
    },
    {
      "code": "604",
      "iso2": "PE",
      "iso3": "PER",
      "currency_code": "PEN",
      "name": "Peru",
      "name_vi": "Pê-ru",
      "flag": "https://cdn.dutycast.com/uploads/flags/peru.svg",
      "row": 9,
      "col": 11,
    },
    {
      "code": "608",
      "iso2": "PH",
      "iso3": "PHL",
      "currency_code": "PHP",
      "name": "Philippines",
      "name_vi": "Phi-líp-pin",
      "flag": "https://cdn.dutycast.com/uploads/flags/philippines.svg",
      "row": 9,
      "col": 12,
    },
    {
      "code": "612",
      "iso2": "PN",
      "iso3": "PCN",
      "currency_code": "NZD",
      "name": "Pitcairn",
      "name_vi": "Quần đảo Pitcairn",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "616",
      "iso2": "PL",
      "iso3": "POL",
      "currency_code": "PLN",
      "name": "Poland",
      "name_vi": "Ba Lan",
      "flag": "https://cdn.dutycast.com/uploads/flags/poland.svg",
      "row": 9,
      "col": 13,
    },
    {
      "code": "620",
      "iso2": "PT",
      "iso3": "PRT",
      "currency_code": "EUR",
      "name": "Portugal",
      "name_vi": "Bồ Đào Nha",
      "flag": "https://cdn.dutycast.com/uploads/flags/portugal.svg",
      "row": 9,
      "col": 14,
    },
    {
      "code": "630",
      "iso2": "PR",
      "iso3": "PRI",
      "currency_code": "USD",
      "name": "Puerto Rico",
      "name_vi": "Pu-éc-tô Ri-cô",
      "flag": "https://cdn.dutycast.com/uploads/flags/puerto-rico.svg",
      "row": 10,
      "col": 0,
    },
    {
      "code": "634",
      "iso2": "QA",
      "iso3": "QAT",
      "currency_code": "QAR",
      "name": "Qatar",
      "name_vi": "Ca-ta",
      "flag": "https://cdn.dutycast.com/uploads/flags/quatar.svg",
      "row": 10,
      "col": 1,
    },
    {
      "code": "642",
      "iso2": "RO",
      "iso3": "ROM",
      "currency_code": "RON",
      "name": "Romania",
      "name_vi": "Ru-ma-ni",
      "flag": "https://cdn.dutycast.com/uploads/flags/romania.svg",
      "row": 10,
      "col": 3,
    },
    {
      "code": "643",
      "iso2": "RU",
      "iso3": "RUS",
      "currency_code": "RUB",
      "name": "Russian Federation",
      "name_vi": "Liên Bang Nga",
      "flag": "https://cdn.dutycast.com/uploads/flags/russia.svg",
      "row": 10,
      "col": 4,
    },
    {
      "code": "646",
      "iso2": "RW",
      "iso3": "RWA",
      "currency_code": "RWF",
      "name": "Rwanda",
      "name_vi": "Ru-an-đa",
      "flag": "https://cdn.dutycast.com/uploads/flags/rwanda.svg",
      "row": 10,
      "col": 5,
    },
    {
      "code": "654",
      "iso2": "SH",
      "iso3": "SHN",
      "currency_code": "SHP",
      "name": "Saint Helena",
      "name_vi": "Xanh Heli-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "659",
      "iso2": "KN",
      "iso3": "KNA",
      "currency_code": "XCD",
      "name": "Saint Kitts and Nevis",
      "name_vi": "Saint Kitts và Nevis",
      "flag": "https://cdn.dutycast.com/uploads/flags/saint-kitts-nevis.svg",
      "row": 10,
      "col": 6,
    },
    {
      "code": "662",
      "iso2": "LC",
      "iso3": "LCA",
      "currency_code": "XCD",
      "name": "Saint Lucia",
      "name_vi": "Xanh Lu-xi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/saint-lucia-na.svg",
      "row": 10,
      "col": 7,
    },
    {
      "code": "666",
      "iso2": "PM",
      "iso3": "SPM",
      "currency_code": "EUR",
      "name": "Saint Pierre and Miquelon",
      "name_vi": "Saint Pierre và Miquelon",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "670",
      "iso2": "VC",
      "iso3": "VCT",
      "currency_code": "XCD",
      "name": "Saint Vincent and the Grenadines",
      "name_vi": "Saint Vincent và Grenadines",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "882",
      "iso2": "WS",
      "iso3": "WSM",
      "currency_code": "WST",
      "name": "Samoa",
      "name_vi": "Xa-moa",
      "flag": "https://cdn.dutycast.com/uploads/flags/samoa.svg",
      "row": 10,
      "col": 8,
    },
    {
      "code": "674",
      "iso2": "SM",
      "iso3": "SMR",
      "currency_code": "EUR",
      "name": "San Marino",
      "name_vi": "Xan Ma-ri-nô",
      "flag": "https://cdn.dutycast.com/uploads/flags/san-marino.svg",
      "row": 10,
      "col": 9,
    },
    {
      "code": "678",
      "iso2": "ST",
      "iso3": "STP",
      "currency_code": "STD",
      "name": "Sao Tome and Principe",
      "name_vi": "São Tomé và Príncipe",
      "flag": "https://cdn.dutycast.com/uploads/flags/sao-tome-and-principe.svg",
      "row": 10,
      "col": 10,
    },
    {
      "code": "682",
      "iso2": "SA",
      "iso3": "SAU",
      "currency_code": "SAR",
      "name": "Saudi Arabia",
      "name_vi": "Ả Rập Xê Út",
      "flag": "https://cdn.dutycast.com/uploads/flags/saudi-arabia.svg",
      "row": 10,
      "col": 11,
    },
    {
      "code": "686",
      "iso2": "SN",
      "iso3": "SEN",
      "currency_code": "XOF",
      "name": "Senegal",
      "name_vi": "Xê-nê-gan",
      "flag": "https://cdn.dutycast.com/uploads/flags/senegal.svg",
      "row": 10,
      "col": 12,
    },
    {
      "code": "688",
      "iso2": "RS",
      "iso3": "SRB",
      "currency_code": "RSD",
      "name": "Serbia",
      "name_vi": "Xéc-bi",
      "flag": "https://cdn.dutycast.com/uploads/flags/serbia.svg",
      "row": 10,
      "col": 13,
    },
    {
      "code": "690",
      "iso2": "SC",
      "iso3": "SYC",
      "currency_code": "SCR",
      "name": "Seychelles",
      "name_vi": "Xây-sen",
      "flag": "https://cdn.dutycast.com/uploads/flags/seychelles.svg",
      "row": 10,
      "col": 14,
    },
    {
      "code": "694",
      "iso2": "SL",
      "iso3": "SLE",
      "currency_code": "SLL",
      "name": "Sierra Leone",
      "name_vi": "Xi-ê-ra Lê-ôn",
      "flag": "https://cdn.dutycast.com/uploads/flags/sierra-leone.svg",
      "row": 11,
      "col": 0,
    },
    {
      "code": "702",
      "iso2": "SG",
      "iso3": "SGP",
      "currency_code": "SGD",
      "name": "Singapore",
      "name_vi": "Singapore",
      "flag": "https://cdn.dutycast.com/uploads/flags/singapore.svg",
      "lang": "sg",
      "row": 11,
      "col": 1,
    },
    {
      "code": "703",
      "iso2": "SK",
      "iso3": "SVK",
      "currency_code": "EUR",
      "name": "Slovakia",
      "name_vi": "Xlô-va-kia",
      "flag": "https://cdn.dutycast.com/uploads/flags/slovakia.svg",
      "row": 11,
      "col": 2,
    },
    {
      "code": "705",
      "iso2": "SI",
      "iso3": "SVN",
      "currency_code": "EUR",
      "name": "Slovenia",
      "name_vi": "Xlô-vê-nia",
      "flag": "https://cdn.dutycast.com/uploads/flags/slovenia.svg",
      "row": 11,
      "col": 3,
    },
    {
      "code": "090",
      "iso2": "SB",
      "iso3": "SLB",
      "currency_code": "SBD",
      "name": "Solomon Islands",
      "name_vi": "Quần đảo Sô-lô-môn",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "706",
      "iso2": "SO",
      "iso3": "SOM",
      "currency_code": "SOS",
      "name": "Somalia",
      "name_vi": "Xô-ma-li",
      "flag": "https://cdn.dutycast.com/uploads/flags/somalia.svg",
      "row": 11,
      "col": 4,
    },
    {
      "code": "710",
      "iso2": "ZA",
      "iso3": "ZAF",
      "currency_code": "ZAR",
      "name": "South Africa",
      "name_vi": "Cộng hòa Nam Phi",
      "flag": "https://cdn.dutycast.com/uploads/flags/south-africa.svg",
      "row": 11,
      "col": 5,
    },
    {
      "code": "239",
      "iso2": "GS",
      "iso3": "SGS",
      "currency_code": "GBP",
      "name": "South Georgia and the South Sandwich Islands",
      "name_vi": "Nam Georgia và Quần đảo Nam Sandwich",
      "flag": "https://cdn.dutycast.com/uploads/flags/south-sandwich-islands.svg",
      "row": 11,
      "col": 6,
    },
    {
      "code": "728",
      "iso2": "SS",
      "iso3": "SSD",
      "currency_code": "SSP",
      "name": "South Sudan",
      "name_vi": "Nam Xu Đăng",
      "flag": "https://cdn.dutycast.com/uploads/flags/south-sudan.svg",
      "row": 11,
      "col": 7,
    },
    {
      "code": "724",
      "iso2": "ES",
      "iso3": "ESP",
      "currency_code": "EUR",
      "name": "Spain",
      "name_vi": "Tây Ban Nha",
      "flag": "https://cdn.dutycast.com/uploads/flags/spain.svg",
      "row": 11,
      "col": 8,
    },
    {
      "code": "144",
      "iso2": "LK",
      "iso3": "LKA",
      "currency_code": "LKR",
      "name": "Sri Lanka",
      "name_vi": "Xri Lan-ca",
      "flag": "https://cdn.dutycast.com/uploads/flags/sri-lanka.svg",
      "row": 11,
      "col": 9,
    },
    {
      "code": "736",
      "iso2": "SD",
      "iso3": "SDN",
      "currency_code": "SDG",
      "name": "Sudan",
      "name_vi": "Xu Đăng",
      "flag": "https://cdn.dutycast.com/uploads/flags/sudan.svg",
      "row": 11,
      "col": 10,
    },
    {
      "code": "740",
      "iso2": "SR",
      "iso3": "SUR",
      "currency_code": "SRD",
      "name": "Suriname",
      "name_vi": "Xu-ri-nam",
      "flag": "https://cdn.dutycast.com/uploads/flags/suriname.svg",
      "row": 11,
      "col": 11,
    },
    {
      "code": "744",
      "iso2": "SJ",
      "iso3": "SJM",
      "currency_code": "NOK",
      "name": "Svalbard and Jan Mayen Islands",
      "name_vi": "Xợ-van-bat và Ian-may-en",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "752",
      "iso2": "SE",
      "iso3": "SWE",
      "currency_code": "SEK",
      "name": "Sweden",
      "name_vi": "Thụy Điển",
      "flag": "https://cdn.dutycast.com/uploads/flags/sweeden.svg",
      "row": 11,
      "col": 13,
    },
    {
      "code": "757",
      "iso2": "CH",
      "iso3": "CHE",
      "currency_code": "CHF",
      "name": "Switzerland",
      "name_vi": "Thụy Sĩ",
      "flag": "https://cdn.dutycast.com/uploads/flags/swiss.svg",
      "row": 11,
      "col": 14,
    },
    {
      "code": "760",
      "iso2": "SY",
      "iso3": "SYR",
      "currency_code": "SYP",
      "name": "Syrian Arab Republic",
      "name_vi": "Cộng hòa Ả Rập Syria",
      "flag": "https://cdn.dutycast.com/uploads/flags/syria.svg",
      "row": 12,
      "col": 0,
    },
    {
      "code": "490",
      "iso2": "TW",
      "iso3": "TWN",
      "currency_code": "TWD",
      "name": "Chinese Taipei",
      "name_vi": "Đài Loan",
      "flag": "https://cdn.dutycast.com/uploads/flags/taiwan.svg",
      "row": 12,
      "col": 1,
    },
    {
      "code": "762",
      "iso2": "TJ",
      "iso3": "TJK",
      "currency_code": "TJS",
      "name": "Tajikistan",
      "name_vi": "Ta-di-ki-xtan",
      "flag": "https://cdn.dutycast.com/uploads/flags/tajikistan.svg",
      "row": 12,
      "col": 2,
    },
    {
      "code": "834",
      "iso2": "TZ",
      "iso3": "TZA",
      "currency_code": "TZS",
      "name": "Tanzania, United Republic of",
      "name_vi": "Tanzania",
      "flag": "https://cdn.dutycast.com/uploads/flags/tanzania.svg",
      "row": 12,
      "col": 3,
    },
    {
      "code": "764",
      "iso2": "TH",
      "iso3": "THA",
      "currency_code": "THB",
      "name": "Thailand",
      "name_vi": "Thái Lan",
      "flag": "https://cdn.dutycast.com/uploads/flags/thailand.svg",
      "row": 12,
      "col": 4,
    },
    {
      "code": "626",
      "iso2": "TP",
      "iso3": "TMP",
      "currency_code": null,
      "name": "Timor-Leste",
      "name_vi": "Đông Ti-mo",
      "flag": "https://cdn.dutycast.com/uploads/flags/east-timor.svg",
      "row": 3,
      "col": 5,
    },
    {
      "code": "768",
      "iso2": "TG",
      "iso3": "TGO",
      "currency_code": "XOF",
      "name": "Togo",
      "name_vi": "Tô-gô",
      "flag": "https://cdn.dutycast.com/uploads/flags/togo.svg",
      "row": 12,
      "col": 5,
    },
    {
      "code": "772",
      "iso2": "TK",
      "iso3": "TKL",
      "currency_code": "NZD",
      "name": "Tokelau",
      "name_vi": "To-ke-lau",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "776",
      "iso2": "TO",
      "iso3": "TON",
      "currency_code": "TOP",
      "name": "Tonga",
      "name_vi": "Tôn-ga",
      "flag": "https://cdn.dutycast.com/uploads/flags/tonga.svg",
      "row": 12,
      "col": 6,
    },
    {
      "code": "780",
      "iso2": "TT",
      "iso3": "TTO",
      "currency_code": "TTD",
      "name": "Trinidad and Tobago",
      "name_vi": "Trinidad và Tobago",
      "flag": "https://cdn.dutycast.com/uploads/flags/trinidad-tobago.svg",
      "row": 12,
      "col": 7,
    },
    {
      "code": "788",
      "iso2": "TN",
      "iso3": "TUN",
      "currency_code": "TND",
      "name": "Tunisia",
      "name_vi": "Tuy-ni-di",
      "flag": "https://cdn.dutycast.com/uploads/flags/tunisia.svg",
      "row": 12,
      "col": 8,
    },
    {
      "code": "792",
      "iso2": "TR",
      "iso3": "TUR",
      "currency_code": "TRY",
      "name": "Turkey",
      "name_vi": "Thổ Nhĩ Kỳ",
      "flag": "https://cdn.dutycast.com/uploads/flags/turkey.svg",
      "row": 12,
      "col": 9,
    },
    {
      "code": "795",
      "iso2": "TM",
      "iso3": "TKM",
      "currency_code": "TMT",
      "name": "Turkmenistan",
      "name_vi": "Tuốc-mê-ni-xtan",
      "flag": "https://cdn.dutycast.com/uploads/flags/turkmenistan.svg",
      "row": 12,
      "col": 10,
    },
    {
      "code": "796",
      "iso2": "TC",
      "iso3": "TCA",
      "currency_code": "USD",
      "name": "Turks and Caicos Islands",
      "name_vi": "Quần đảo Turks và Caicos",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "798",
      "iso2": "TV",
      "iso3": "TUV",
      "currency_code": "AUD",
      "name": "Tuvalu",
      "name_vi": "Tu-va-lu",
      "flag": "https://cdn.dutycast.com/uploads/flags/tuvalu.svg",
      "row": 12,
      "col": 11,
    },
    {
      "code": "800",
      "iso2": "UG",
      "iso3": "UGA",
      "currency_code": "UGX",
      "name": "Uganda",
      "name_vi": "U-gan-đa",
      "flag": "https://cdn.dutycast.com/uploads/flags/uganda.svg",
      "row": 12,
      "col": 12,
    },
    {
      "code": "804",
      "iso2": "UA",
      "iso3": "UKR",
      "currency_code": "UAH",
      "name": "Ukraine",
      "name_vi": "U-crai-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/ukraine.svg",
      "row": 12,
      "col": 14,
    },
    {
      "code": "784",
      "iso2": "AE",
      "iso3": "ARE",
      "currency_code": "AED",
      "name": "United Arab Emirates",
      "name_vi": "Các Tiểu vương quốc Ả Rập Thống nhất",
      "flag": "https://cdn.dutycast.com/uploads/flags/united-arab-emirates.svg",
      "row": 13,
      "col": 0,
    },
    {
      "code": "826",
      "iso2": "GB",
      "iso3": "GBR",
      "currency_code": "GBP",
      "name": "United Kingdom",
      "name_vi": "Anh",
      "flag": "https://cdn.dutycast.com/uploads/flags/uk.svg",
      "row": 12,
      "col": 13,
    },
    {
      "code": "849",
      "iso2": "UM",
      "iso3": "UMI",
      "currency_code": "USD",
      "name": "United States Minor Outlying Islands",
      "name_vi": "Các tiểu đảo xa của Hoa Kỳ",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "842",
      "iso2": "US",
      "iso3": "USA",
      "currency_code": "USD",
      "name": "United States of America",
      "name_vi": "Mỹ",
      "flag": "https://cdn.dutycast.com/uploads/flags/usa.svg",
      "row": 13,
      "col": 3,
    },
    {
      "code": "858",
      "iso2": "UY",
      "iso3": "URY",
      "currency_code": "UYU",
      "name": "Uruguay",
      "name_vi": "U-ru-guay",
      "flag": "https://cdn.dutycast.com/uploads/flags/uruguay.svg",
      "row": 13,
      "col": 1,
    },
    {
      "code": "860",
      "iso2": "UZ",
      "iso3": "UZB",
      "currency_code": "UZS",
      "name": "Uzbekistan",
      "name_vi": "U-dơ-bê-ki-xtan",
      "flag": "https://cdn.dutycast.com/uploads/flags/uzbekistan.svg",
      "row": 13,
      "col": 4,
    },
    {
      "code": "548",
      "iso2": "VU",
      "iso3": "VUT",
      "currency_code": "VUV",
      "name": "Vanuatu",
      "name_vi": "Va-nu-a-tu",
      "flag": "https://cdn.dutycast.com/uploads/flags/vanuatu.svg",
      "row": 13,
      "col": 5,
    },
    {
      "code": "862",
      "iso2": "VE",
      "iso3": "VEN",
      "currency_code": "VES",
      "name": "Venezuela (Bolivarian Republic of)",
      "name_vi": "Vê-nê-du-ê-la",
      "flag": "https://cdn.dutycast.com/uploads/flags/venezuela.svg",
      "row": 13,
      "col": 6,
    },
    {
      "code": "704",
      "iso2": "VN",
      "iso3": "VNM",
      "currency_code": "VND",
      "name": "Viet Nam",
      "name_vi": "Việt Nam",
      "flag": "https://cdn.dutycast.com/uploads/flags/vietnam.svg",
      "lang": "vi",
      "row": 13,
      "col": 7,
    },
    {
      "code": "092",
      "iso2": "VG",
      "iso3": "VGB",
      "currency_code": "USD",
      "name": "Virgin Islands, British",
      "name_vi": "Quần Đảo Virgin Anh",
      "flag": "https://cdn.dutycast.com/uploads/flags/british-virgin-islands.svg",
      "row": 1,
      "col": 9,
    },
    {
      "code": "850",
      "iso2": "VI",
      "iso3": "VIR",
      "currency_code": "USD",
      "name": "Virgin Islands, United States",
      "name_vi": "Quần Đảo Virgin Mỹ",
      "flag": "https://cdn.dutycast.com/uploads/flags/us-virgin-islands.svg",
      "row": 13,
      "col": 2,
    },
    {
      "code": "876",
      "iso2": "WF",
      "iso3": "WLF",
      "currency_code": "XPF",
      "name": "Wallis and Futuna",
      "name_vi": "Oua-li-xợ va Phu-tu-na",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "732",
      "iso2": "EH",
      "iso3": "ESH",
      "currency_code": "MAD",
      "name": "Western Sahara",
      "name_vi": "Tây Sa-ha-ra",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "887",
      "iso2": "YE",
      "iso3": "YEM",
      "currency_code": "YER",
      "name": "Yemen",
      "name_vi": "Y-ê-men",
      "flag": "https://cdn.dutycast.com/uploads/flags/yemen.svg",
      "row": 13,
      "col": 8,
    },
    {
      "code": "894",
      "iso2": "ZM",
      "iso3": "ZMB",
      "currency_code": "ZMW",
      "name": "Zambia",
      "name_vi": "Dăm-bi-a",
      "flag": "https://cdn.dutycast.com/uploads/flags/zambia.svg",
      "row": 13,
      "col": 9,
    },
    {
      "code": "716",
      "iso2": "ZW",
      "iso3": "ZWE",
      "currency_code": "USD",
      "name": "Zimbabwe",
      "name_vi": "Dim-ba-bu-ê",
      "flag": "https://cdn.dutycast.com/uploads/flags/zimbabwe.svg",
      "row": 13,
      "col": 10,
    },
    {
      "code": "833",
      "iso2": "IM",
      "iso3": "IMN",
      "currency_code": "GBP",
      "name": "Isle of Man",
      "name_vi": "Đảo Man",
      "flag": "https://cdn.dutycast.com/uploads/flags/isle-of-man.svg",
      "row": 5,
      "col": 13,
    },
    {
      "code": "492",
      "iso2": "MC",
      "iso3": "MCO",
      "currency_code": "EUR",
      "name": "Monaco",
      "name_vi": "Monaco",
      "flag": "https://cdn.dutycast.com/uploads/flags/monaco.svg",
      "row": 8,
      "col": 5,
    },
    {
      "code": "638",
      "iso2": "RE",
      "iso3": "REU",
      "currency_code": "EUR",
      "name": "Réunion",
      "name_vi": "Réunion",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "474",
      "iso2": "MQ",
      "iso3": "MTQ",
      "currency_code": "EUR",
      "name": "Martinique",
      "name_vi": "Martinique",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "312",
      "iso2": "GP",
      "iso3": "GLP",
      "currency_code": "EUR",
      "name": "Guadeloupe",
      "name_vi": "Guadeloupe",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "533",
      "iso2": "AW",
      "iso3": "ABW",
      "currency_code": "AWG",
      "name": "Aruba",
      "name_vi": "Aruba",
      "flag": "https://cdn.dutycast.com/uploads/flags/dutycast-flag.svg",
      "row": 0,
      "col": 0,
    },
    {
      "code": "832",
      "iso2": "JE",
      "iso3": "JEY",
      "currency_code": "GBP",
      "name": "Jersey",
      "name_vi": "Jersey",
      "flag": "https://cdn.dutycast.com/uploads/flags/jersey.svg",
      "row": 6,
      "col": 3,
    },
  ]
}